import React, { Component } from "react";
import axios from "axios";
import GMlookupCombo3 from '../GMlookupCombo3/GMlookupCombo3'
import "./BibleForce.css"
import {globals} from "../Globals/Globals"

class BibleForce extends Component{

    constructor (props){
        super(props)
        this.state = {bookId:1, chapterId:1, bible_text:[], bookName:"Genèse"}
    }

    componentDidMount = () => {
        //Initial Bible content loading
        this.loadBibleContent()
    }

    loadBibleContent = async () => {
        let bibleServiceResult = await axios.post(globals.bible_text_endpoint.url, {bookId:this.state.bookId, chapterId:this.state.chapterId})
        if (globals.parameters.debugging)
            console.log("bibleServiceResult:", bibleServiceResult, "err_code:",bibleServiceResult.data.err_code)
        if ((bibleServiceResult.data.state == true) && (bibleServiceResult.data.items.length > 0)){
            this.setState(
                {bible_text:bibleServiceResult.data.items}
            )
        }
    }

    render = () => {
        return(<div className="bible-force">
                <div className="bible-title">
                    <h2>La Bible Segond 1910</h2>
                    <div className="bible-nav-bar"> 
                            <div className="bible-bar-combo">
                                <GMlookupCombo3
                                    keyFieldName = "book_id" //Field name on wich selection is made on table
                                    fieldName = "name" //Field name displayed on list
                                    activeSelectionKeyValue={this.state.bookId}  //Active selection to be displayed by default. Not used on creation (optionnal)
                                    searchEnabled = {false} //Display an incremental input search field
                                    localURL = {globals.bible_books_endpoint.url} //micro service local with returns data set
                                    remoteURL = {globals.bible_books_endpoint.url} //Production micro service wich returns data set
                                    OnSelect = {(itemsObjectItem)=>{this.setState({bookId:itemsObjectItem.book_id, chapterId:1, bookName:itemsObjectItem.name}, ()=>{this.loadBibleContent()})}}
                                    /> {/*On selection handler*/}
                            </div>

                            <div className="bible-bar-combo">
                                <GMlookupCombo3
                                    keyFieldName = "chapter_id"
                                    fieldName = "chapter_id"
                                    activeSelectionKeyValue={this.state.chapterId}  //Active selection to be displayed by default. Not used on creation (optionnal)
                                    getLookupParameterName = "bookId" //Parameter name that will be use on GET request 
                                    getLookupParameterValue = {this.state.bookId}
                                    
                                    searchEnabled = {false}
                                    localURL = {globals.bible_chapters_endpoint.url}
                                    remoteURL = {globals.bible_chapters_endpoint.url}
                                    OnSelect = {(itemsObjectItem)=>{this.setState({chapterId:itemsObjectItem.chapter_id}, ()=>{this.loadBibleContent()})}}
                                    />
                            </div>
                    </div>
                </div>

                {/*
                <div className="bible-bar-active-selection">
                    <div>
                        <span>{this.state.bookName}</span>
                        <span>&nbsp;</span>
                        <span>{this.state.chapterId}</span>
                    </div>
                </div>*/}


                {this.state.bible_text.length > 0 &&
                    <div className="bible-component">
                        <div className="bible-text-container">
                            {this.state.bible_text.map(
                                verseItem => {
                                    return(
                                        <div key={verseItem.auto_id}>
                                            <span className="verse-number">{verseItem.verse_id}</span>
                                            <span className="verse-text">{verseItem.text}</span>
                                        </div>
                                    )})}
                        </div>
                    </div>}
            </div>
        )
    }
}

export default BibleForce;